export default "__VITE_ASSET__92166086__"